import { serverCall } from 'utils/serverCall';
import {
  initOilByCompanyRequest,
  setOilByCompany,
  errorOilByCompany
} from './action';
import apiEndpoints from 'utils/apiList';
import toast from 'react-hot-toast';

export const fetchOilByCompanyId = (companyId) => {
  return async (dispatch) => {
    dispatch(initOilByCompanyRequest());
    try {
      const result = await serverCall(`${apiEndpoints.OIL_BY_COMPANY}/${companyId}`, 'GET', dispatch);
      if (result.success) {
        dispatch(setOilByCompany(result?.data?.payload));
      } else {
        dispatch(errorOilByCompany(result.message));
      }
    } catch (error) {
      dispatch(errorOilByCompany(error.message));
    }
  };
};
